// composables/chat-stream.js
const resolveStream = async ({
  data,
  onChunk = () => { },
  onReady = () => { },
  stream,
}) => {
  const reader = stream.pipeThrough(new TextDecoderStream()).getReader();
  
  while (true) {
    const stream = await reader.read();
    
    if (stream.done) {
      break;
    }

    const content = stream.value;
    
    if (content) {
      data.value += content;
      onChunk({ data: content });
    }
  }

  onReady({ data: data.value });
};

export const useChatStream = ({
  onChunk = () => { },
  onReady = () => { },
  stream,
}) => {
  const data = ref("");

  resolveStream({
    data,
    onChunk,
    onReady,
    stream,
  });

  return {
    data: readonly(data),
  };
};

// const resolveStream = async ({
//   data,
//   onChunk = () => {},
//   onReady = () => {},
//   onFunctionToCall = () => {},
//   stream,
// }) => {
//   const reader = stream.pipeThrough(new TextDecoderStream()).getReader();


//   let function_to_call = {
//     name: '',
//     arguments: ''
//   }

//   while (true) {
//     const stream = await reader.read();
//     if (stream.done) break;

//     const chunks = stream?.value
//       .replaceAll(/^data: /gm, "")
//       .split("\n")
//       .filter((c) => Boolean(c.length) && c !== "[DONE]")
//       .map((c) => JSON.parse(c));

//     for (let chunk of chunks) {
//       // console.log('chunk:', chunk);
//       const content = chunk.choices[0].delta.content

//       if (chunk.choices[0].delta.function_call?.name) { 
//         // we're calling a function with a name
//         function_to_call.name = chunk.choices[0].delta.function_call.name
//       } else if (chunk.choices[0].delta.function_call?.arguments) {
//         // 
//         function_to_call.arguments += chunk.choices[0].delta.function_call.arguments
//       }

//       if (!content) continue;
//       data.value += chunk.choices[0].delta.content;
//       onChunk({ data: content });
//     }

    
//   }
  
//   if (function_to_call.name) {
//     function_to_call.arguments = JSON.parse(function_to_call.arguments)
//     onFunctionToCall({ data: function_to_call })
//     function_to_call = {
//       name: '',
//       arguments: ''
//     }
//   }
  
//   onReady({ data: data.value });
// };

// export const useChatStream = ({
//   onChunk = () => {},
//   onReady = () => {},
//   onFunctionToCall = () => {},
//   stream,
// }) => {
//   const data = ref("");

//   resolveStream({
//     data,
//     onChunk,
//     onReady,
//     stream,
//     onFunctionToCall
//   });

//   return {
//     data: readonly(data),
//   };
// };